import Vue from 'vue';
import moment from 'moment'
import { pinyin } from 'pinyin-pro';

import router from '../router'
import store from '../store'
import printJS from 'print-js'

import NP from "number-precision";
const vueObject = new Vue({
    store,
    router
});

function isNull(value) {
    if (!value && typeof value != "undefined" && value != 0) {
        return true;
    } else {
        return false;
    }
}

function addt(m) { return m < 10 ? '0' + m : m }
export default {
    // 处理表格头部拖拽事件，保存列宽到fieldWeight字段 @header-dragend="(newWidth, oldWidth, column, event)=>$common.handleHeaderDragend(newWidth, oldWidth, column, event,pageShowData.jurTableVo.jurconfigtable)"
    handleHeaderDragend(newWidth, oldWidth, column, event, tableList) {
        // 找到对应的列配置并更新fieldWeight字段
        const tableConfig = tableList;
        const columnIndex = tableConfig.findIndex(config => config.entityField === column.property);

        if (columnIndex !== -1) {
            // 更新fieldWidth为当前宽度（拖拽后的新宽度）
            Vue.set(tableConfig[columnIndex], 'fieldWeight', this.getDecimalInfo(3, newWidth));
            // 如果需要将更改保存到服务器，可以在这里调用API
            // this.saveColumnWidthToServer(tableConfig[columnIndex]);
        }
    },
    remove() {
        setTimeout(() => {
            Vue.prototype.$dbCache.Record_GetAll().then(res => {
                var list = res
                if (list.length == 0) {
                    return
                }
                list.forEach(item => {
                    Vue.prototype.$dbCache.Record_Remove(item.id).then((msg) => {
                        console.log('删除成功');
                    }).catch(err => {
                        console.log("删除--->", err);
                    });
                })
            })
        }, 16.7)
    },
    routeLog(val) {
        console.log('跳转', val);
    },
    //get请求 ?拼接的参数返回
    getUrl(val) {
        var str = ""
        for (const key in val) {
            if (val[key] === "") {
                str = `${str}&${key}=`
            } else {
                str = `${str}&${key}=${val[key]}`
            }
        }
        str = str.substring(1, str.length)
        str = '?' + str
        return str
    },
    //时间戳转换时间方法
    getLocalTime(shijianchuo, isDetailed,) {
        shijianchuo = Number(shijianchuo)
        if (isNull(shijianchuo) || !shijianchuo || shijianchuo == '') {
            return ''
        }
        var str = shijianchuo.toString()
        if (str.substring(str.length - 4) == '0001') {
            var time = new Date(parseInt(shijianchuo - 1));
            var y = time.getFullYear();
            var m = time.getMonth() + 1;
            return y + '-' + addt(m);
        }
        //shijianchuo是整数，否则要parseInt转换
        if (shijianchuo && shijianchuo != null) {
            var time = new Date(shijianchuo);
            var y = time.getFullYear();
            var m = time.getMonth() + 1;
            var d = time.getDate();
            var h = time.getHours();
            var mm = time.getMinutes();
            var s = time.getSeconds();
            return isDetailed ? y + '-' + addt(m) + '-' + addt(d) + ' ' + addt(h) + ':' + addt(mm) + ':' + addt(s) : y + '-' + addt(m) + '-' + addt(d);
        }
    },
    //生成图片链接
    getFileAddress(filePath) {
        console.log(filePath);

        var thisPath = vueObject.$store.getters.getConfig.imgUrl + '/' + filePath
        console.log(thisPath);
        return thisPath
    },
    //批量生成图片链接
    getFileAddressARR(filePathArr) {
        let arr = []
        filePathArr.forEach(item => {
            arr.push(vueObject.$store.getters.getConfig.imgUrl + '/' + item)
        })
        return arr
    },
    generateUUID() {
        var d = new Date().getTime();
        if (window.performance && typeof window.performance.now === "function") {
            d += performance.now(); //use high-precision timer if available
        }
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        return uuid;
    },
    //处理不同字符数量的文字间距
    labelStyle(str) {
        if (str.length == 4 || str.length == 2) {
            return 'letter-spacing:2px;'
        } else if (str.length == 3) {
            return 'letter-spacing:2.7px;'
        } else {
            return ''
        }
    },
    htmlLabel(val) {
        if (String(val).length == 2) {
            return val.split("")[0] + '&nbsp;&nbsp;&thinsp;&thinsp;&thinsp;&thinsp;' + val.split("")[1]
        } else if (String(val).length == 3) {
            return val.split("")[0] + '&nbsp;' + val.split("")[1] + '&nbsp;' + val.split("")[2]
        } else {
            return val
        }
    },
    /**
     * 判断一个变量是不是一个Json字符串
     * @param  {[type]}  str [description]
     * @return {Boolean}     [description]
     */
    isJSON(str) {
        if (typeof str == 'string') {
            try {
                var obj = _parseJSON(str);
                if (typeof obj == 'object' && obj) {
                    return true;
                } else {
                    return false;
                }

            } catch (e) {
                return false;
            }
        }

        return false;
    },
    /**
     * 日志打印
     * @param {Object} data
     * 
     */
    console(data) {
        if (vueObject.$store.state.webConfig.type == 1) {
            console.log(data)
        }
    },

    // 文件下载
    fileDownloads(filePath, fileName) {
        const blob = new Blob([filePath]) // 构造一个blob对象来处理数据
        // const fileName = fileName  // 导出文件名
        // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
        // IE10以上支持blob但是依然不支持download
        if ('download' in document.createElement('a')) { // 支持a标签download的浏览器
            const link = document.createElement('a') // 创建a标签
            link.download = fileName // a标签添加属性
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            document.body.appendChild(link)
            link.click() // 执行下载
            URL.revokeObjectURL(link.href) // 释放url
            document.body.removeChild(link) // 释放标签
        } else { // 其他浏览器
            navigator.msSaveBlob(blob, fileName)
        }
    },
    //动态表单检索条件的数据初始化
    getSearchData(jurHead, page, row, number, flag = true, pageShow = true) {
        var getRequestData = {}
        var day = 30
        if (JSON.parse(sessionStorage.getItem('printInfo')).days || JSON.parse(sessionStorage.getItem('printInfo')).days == 0) {
            day = JSON.parse(sessionStorage.getItem('printInfo')).days
        }
        if (!flag) {
            day = 7
        }
        jurHead.forEach(item => {
            if (item.fieldType == 'date') {
                Vue.set(getRequestData, 'start', new Date(new Date().toLocaleDateString()).getTime() - day * 24 * 3600 * 1000)
                Vue.set(getRequestData, 'end', new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            } else if (item.fieldType == "search" && item.setField) {
                var arr = item.setField.split(",")
                arr.forEach(item1 => {
                    Vue.set(getRequestData, item1, "")
                })
            } else {
                if (item.defaultValue) {
                    Vue.set(getRequestData, item.entityField, String(Number(item.defaultValue)) == 'NaN' ? item.defaultValue : Number(item.defaultValue))
                } else {
                    Vue.set(getRequestData, item.entityField, "")
                }
            }
        })
        if (pageShow) {
            Vue.set(getRequestData, row, number)
            Vue.set(getRequestData, page, 1)
        }
        return getRequestData
    },
    //写死的检索条件的数据初始化
    getSearch(data, start, end, page, row, number, flag = true, pageShow = true) {
        var getRequestData = {}
        var day = 30
        if (JSON.parse(sessionStorage.getItem('printInfo')).days || JSON.parse(sessionStorage.getItem('printInfo')).days == 0) {
            day = JSON.parse(sessionStorage.getItem('printInfo')).days
        }
        if (!flag) {
            day = 7
        }
        for (const key in data) {
            if (key == start || key == end) {
                Vue.set(getRequestData, start, new Date(new Date().toLocaleDateString()).getTime() - day * 24 * 3600 * 1000)
                Vue.set(getRequestData, end, new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            } else {
                Vue.set(getRequestData, key, "")
            }
        }
        if (pageShow) {
            Vue.set(getRequestData, row, number)
            Vue.set(getRequestData, page, 1)
        }
        return getRequestData
    },
    //表单提交初始数据渲染
    filterMainFields(list, entityFieldlist, obj) {
        var sendDataInfo = {};
        // 判断是否有有效默认值（保留 0 / false）
        var hasDefault = function (val) {
            return val !== "" && val !== null && val !== undefined;
        };
        // 可转数字则转 Number，否则保留原值
        var parseMaybeNumber = function (val) {
            var num = Number(val);
            return isNaN(num) ? val : num;
        };
        // 按字段类型写入默认值；skipEmptyRadio 为 true 时 radio 无默认值不赋值（子表逻辑）
        var setFieldDefault = function (item, skipEmptyRadio) {
            var field = item.entityField;
            var type = item.fieldType;
            var val = item.defaultValue;
            if (type === 'number') {
                Vue.set(sendDataInfo, field, hasDefault(val) ? Number(val) : 0);
            } else if (type === 'string') {
                Vue.set(sendDataInfo, field, hasDefault(val) ? val : "");
            } else if (type === 'search' && item.setField) {
                item.setField.split(',').forEach(function (f) {
                    Vue.set(sendDataInfo, f, "");
                });
                if (hasDefault(val)) {
                    Vue.set(sendDataInfo, field, val);
                }
            } else if (type === 'radio') {
                if (hasDefault(val)) {
                    Vue.set(sendDataInfo, field, parseMaybeNumber(val));
                } else if (!skipEmptyRadio) {
                    Vue.set(sendDataInfo, field, "");
                }
            } else {
                // formatter 及其他类型：能转数字则转，否则保留字符串；无默认值为 ""
                Vue.set(sendDataInfo, field, hasDefault(val) ? parseMaybeNumber(val) : "");
            }
        };
        if (list && list.length > 0) {
            list.forEach(function (item) {
                if (item.jciType == 3) {
                    item.jurconfigform.forEach(function (item1) {
                        setFieldDefault(item1, true);
                    });
                }
            });
        }
        if (entityFieldlist && entityFieldlist.length > 0) {
            entityFieldlist.forEach(function (item) {
                Vue.set(sendDataInfo, item.entityField, []);
            });
        }
        if (obj != undefined) {
            obj.jurconfigform.forEach(function (item) {
                setFieldDefault(item, false);
            });
        }
        return sendDataInfo;
    },
    // 字段空值判断（null / undefined / ''）
    isEmptyFieldValue(val) {
        return val === null || val === undefined || val === "";
    },
    /**
     * 校验明细行必填字段（根据动态表单 isRequired==1 且 isShow==1）
     * @param {Array} formConfig 明细动态表单配置（如 mxForm）
     * @param {Array} detailList 明细数据列表
     * @param {Object} options 可选配置
     * @param {string} options.rowLabelField 行标识字段名，如 bgmName
     * @returns {Object|null} 校验失败返回 { rowIndex, entityField, showField, message }，成功返回 null
     */
    //使用方式
    // const detailValidateResult = this.$common.validateDetailRequiredFields(
    //     this.mxForm,
    //     this.sendDataInfo.desuRgapplyDetails,
    //     { rowLabelField: 'bgmName' }
    // )
    // if (detailValidateResult) {
    //     return this.$message.error(detailValidateResult.message)
    // }
    validateDetailRequiredFields(formConfig, detailList, options = {}) {
        const requiredFields = (formConfig || [])
            .filter(item => item.isRequired == 1 && item.isShow == 1&&item.isChange == 1)
            .map(item => ({
                entityField: item.entityField,
                showField: item.showField,
            }));

        if (!requiredFields.length || !detailList || !detailList.length) {
            return null;
        }

        const { rowLabelField } = options;

        for (let rowIndex = 0; rowIndex < detailList.length; rowIndex++) {
            const row = detailList[rowIndex];
            for (let i = 0; i < requiredFields.length; i++) {
                const field = requiredFields[i];
                if (this.isEmptyFieldValue(row[field.entityField])) {
                    const rowLabel = rowLabelField && row[rowLabelField] ? row[rowLabelField] : "";
                    const message = rowLabel
                        ? `第${rowIndex + 1}行的${rowLabel}${field.showField}不能为空！`
                        : `第${rowIndex + 1}行的${field.showField}不能为空！`;
                    return {
                        rowIndex,
                        entityField: field.entityField,
                        showField: field.showField,
                        message,
                    };
                }
            }
        }
        return null;
    },
    // search 必填：名称与 requiredField 中配置的 id 字段均不能为空
    validateRequiredSearchField(formOneValue, formData, callback) {
        const nameVal = formData[formOneValue.entityField];
        if (this.isEmptyFieldValue(nameVal)) {
            return callback(new Error("必填"));
        }
        if (formOneValue.requiredField) {
            const fields = formOneValue.requiredField.split(",").filter((f) => f);
            for (let i = 0; i < fields.length; i++) {
                if (this.isEmptyFieldValue(formData[fields[i]])) {
                    return callback(new Error("必填"));
                }
            }
        }
        callback();
    },
    // 主表单校验规则：search 必填项需名称与关联 id 均非空
    getFormItemRules(formOneValue, formData) {
        if (formOneValue.isRequired != 1) return [];
        if (formOneValue.fieldType == "search") {
            return [
                {
                    required: true,
                    validator: (rule, value, callback) => {
                        this.validateRequiredSearchField(formOneValue, formData, callback);
                    },
                    trigger: ["blur", "change"],
                },
            ];
        }
        return [{ required: true, trigger: ["blur", "change"] }];
    },
    // 检索框清除：按 requiredField 同步清空关联 Id 等字段
    clearSearch(formData, setField, type) {
        if (!formData || !setField) return;
        if (type) {
            if (formData[type] === "") {
                setField.split(",").filter((f) => f).forEach((item) => {
                    formData[item] = "";
                });
            }
            return
        } else {
            setField.split(",").filter((f) => f).forEach((item) => {
                formData[item] = "";
            });
            return
        }
    },
    getIndex(list) {
        list.forEach((item, index) => {
            Vue.set(item, 'index', index)
        })
        return list
    },
    //获取列表页的高度
    getTableHeight() {
        var tableHeight = document.documentElement.querySelector(".page_content").clientHeight
        var tabHeight = 0
        if (document.documentElement.querySelector(".page_content_top")) {
            if (document.documentElement.querySelector(".page_content_top").clientHeight > 0) {
                tabHeight = document.documentElement.querySelector(".page_content_top").clientHeight
            }
        }
        if (document.documentElement.querySelector(".page_content_top_second")) {
            if (document.documentElement.querySelector(".page_content_top_second").clientHeight > 0) {
                tabHeight = document.documentElement.querySelector(".page_content_top_second").clientHeight
            }
        }
        var h = 0
        if (document.documentElement.querySelector(".page_content_top_line1")) {
            h = 35
        }
        console.log(tableHeight, tabHeight);

        var tableHeight
        if (tableHeight - 200 < tabHeight + 40 + h) {
            tableHeight = 200
            if (document.documentElement.querySelector(".page_content").querySelector(".el-table__fixed-right")) {
                document.documentElement.querySelector(".page_content").querySelector(".el-table__fixed-right").style = `height:${tableHeight - 5}px`
            }
            return tableHeight
        }
        if (document.documentElement.querySelector(".page_content").querySelector("#vtab")) {
            tableHeight = tableHeight - tabHeight - 90 - h

        } else {

            tableHeight = tableHeight - tabHeight - 50 - h
        }
        if (document.documentElement.querySelector(".page_content").querySelector(".el-table__fixed-right")) {
            document.documentElement.querySelector(".page_content").querySelector(".el-table__fixed-right").style = `height:${tableHeight - 5}px`
        }
        return tableHeight

    },
    //获取弹框的高度（穿梭框）
    getHeight() {
        var totalHeight = document.documentElement.querySelector(".el-drawer__body").clientHeight
        //顶部按钮
        var headHeight = 0
        var headTabHeight = 0
        if (document.documentElement.querySelector(".el-drawer__body").querySelector(".btns")) {
            headHeight = document.documentElement.querySelector(".el-drawer__body").querySelector(".btns").clientHeight
        }
        if (document.documentElement.querySelector(".el-drawer__body").querySelector(".el-tabs__header")) {
            headTabHeight = document.documentElement.querySelector(".el-drawer__body").querySelector(".el-tabs__header").clientHeight
        }
        var tabHeight = 0
        var sheight = 0
        var btnHeight1 = 0
        var footHeight = 0
        var treeHeight = 0
        var arr = document.documentElement.querySelector(".el-drawer__body").querySelector(".el-tabs__content").childNodes
        var tableHeight = 0
        arr.forEach(item => {
            if (item.getAttribute("aria-hidden") != 'true') {
                tabHeight = item.querySelector(".v_tabs").clientHeight
                var arr1 = item.querySelector("#vtab").childNodes
                arr1.forEach(item1 => {
                    if (item1.style != undefined && item1.style[0] != 'display') {
                        if (item1.querySelector("#mainInfo")) {
                            sheight = item1.querySelector("#mainInfo").clientHeight
                        }
                        if (item1.querySelector("#operateBtn1")) {
                            btnHeight1 = item1.querySelector("#operateBtn1").clientHeight + 14
                        }
                    }
                })
                if (item.querySelector(".data_action_form").querySelector(".foot")) {
                    footHeight = item.querySelector(".data_action_form").querySelector(".foot").clientHeight
                } else if (item.querySelector(".data_action_form").querySelector(".foot1")) {
                    footHeight = item.querySelector(".data_action_form").querySelector(".foot1").clientHeight
                }
                if (item.querySelector(".data_action_form").querySelector(".tree")) {
                    treeHeight = item.querySelector(".data_action_form").querySelector(".tree").clientHeight
                }
                document.documentElement.querySelector(".el-drawer__body").style = `padding-bottom:${footHeight}px`
            }
            if (totalHeight / 2 < (headHeight + headTabHeight + tabHeight + sheight + treeHeight)) {
                tableHeight = 300
            } else {
                tableHeight = totalHeight - headHeight - headTabHeight - tabHeight - sheight - footHeight - 40 - btnHeight1 - treeHeight;
            }
            if (item.querySelector(".el-table__fixed-right")) {
                item.querySelector(".el-table__fixed-right").style = `height:${tableHeight - 5}px`
            }
        })
        return tableHeight
        // this.mxHeight = totalHeight -headHeight-headTabHeight- tabHeight- sheight - footHeight - 40;
    },
    //获取弹框的高度(有按钮)
    getBtnHeight() {
        var totalHeight = document.documentElement.querySelector(".el-drawer__body").clientHeight
        var arr = []
        if (document.documentElement.querySelector('.el-drawer__wrapper').querySelector("#vtab")) {
            arr = document.documentElement.querySelector('.el-drawer__wrapper').querySelector("#vtab").childNodes
        } else {
            arr = document.documentElement.querySelector('#drawerBox').querySelector("#vtab").childNodes

        }
        if (totalHeight == 0) {
            totalHeight = document.documentElement.querySelector("#drawerBox").clientHeight
        }
        var tabHeight = 0
        if (document.documentElement.querySelector(".el-drawer__body").querySelector(".v_tabs")) {
            tabHeight = document.documentElement.querySelector(".el-drawer__body").querySelector(".v_tabs").clientHeight
        } else {
            tabHeight = document.documentElement.querySelector("#drawerBox").querySelector(".v_tabs").clientHeight
        }
        // console.log(document.documentElement);
        //表单的高度
        // var arr = document.documentElement.querySelector('.el-drawer__wrapper').querySelector("#vtab").childNodes
        var sheight = 0
        var btnHeight = 0
        var btnHeight1 = 0
        //按钮高度
        //表尾的高度
        var footHeight = 0
        var tableHeight = 0
        // 
        if (document.documentElement.querySelector(".el-drawer__body").querySelector(".foot")) {
            footHeight = document.documentElement.querySelector(".el-drawer__body").querySelector(".foot").clientHeight
        } else if (document.documentElement.querySelector(".el-drawer__body").querySelector(".foot1")) {
            footHeight = document.documentElement.querySelector(".el-drawer__body").querySelector(".foot1").clientHeight
        } else if (document.documentElement.querySelector("#drawerBox")) {
            if (document.documentElement.querySelector("#drawerBox").querySelector(".foot")) {
                footHeight = document.documentElement.querySelector("#drawerBox").querySelector(".foot").clientHeight
            } else if (document.documentElement.querySelector("#drawerBox").querySelector(".foot1")) {
                footHeight = document.documentElement.querySelector("#drawerBox").querySelector(".foot1").clientHeight
            }
        }
        document.documentElement.querySelector(".el-drawer__body").style = `padding-bottom:${footHeight}px`
        arr.forEach(item => {
            if (item.style != undefined && item.style[0] != 'display') {
                if (item.querySelector("#mainInfo")) {
                    sheight = item.querySelector("#mainInfo").clientHeight
                }
                if (item.querySelector("#operateBtn")) {
                    btnHeight = item.querySelector("#operateBtn").clientHeight
                }
                if (item.querySelector("#operateBtn1")) {
                    btnHeight1 = item.querySelector("#operateBtn1").clientHeight + 14
                }
                if ((totalHeight / 2) + 44 < sheight + footHeight + btnHeight && btnHeight1 != 0) {
                    tableHeight = 600
                } else if ((totalHeight / 2) + 44 < sheight + footHeight + btnHeight) {
                    tableHeight = 300
                } else {
                    tableHeight = totalHeight - sheight - footHeight - 30 - tabHeight - btnHeight - btnHeight1;
                }
                if (item.querySelector(".el-table__fixed-right")) {
                    item.querySelector(".el-table__fixed-right").style = `height:${tableHeight - 5}px`
                }
            }
        })
        return tableHeight
    },

    // 生成编码
    createCode() {
        return moment().valueOf() + this.randomNum(100, 999).toString()
    },

    // 生成人员编码
    createUserCode() {
        return 'UX' + moment().valueOf() + this.randomNum(100, 999).toString()
    },

    //保留n位小数
    roundFun(value, n) {
        return Math.round(value * Math.pow(10, n)) / Math.pow(10, n);
    },

    // 生成人员分组编码
    createUserGroupCode() {
        return 'UG' + moment().valueOf() + this.randomNum(100, 999).toString()
    },

    // 生成组织编码
    async createOrgCode(superiorCode = '', pid) {
        if (pid == -1) {
            pid = 0
        }
        var list = await this.getALLOrgData()
        var sonList = this.getSubTree(list, pid, 0)
        var sonLength = sonList.length + 1;
        var returnCode = superiorCode + ((sonLength / 10) < 1 ? sonLength.toString().padStart(2, '0') : sonLength);
        if (pid == 0) {
            returnCode = 'A' + ((sonLength / 10) < 1 ? sonLength.toString().padStart(2, '0') : sonLength);
        }
        return returnCode
    },

    // 生成部门编码
    async createDepartmentCode(superiorCode = '', pid) {
        if (pid == -1) {
            pid = 0
        }
        var list = await this.getAllDepartmentList()
        var sonList = this.departmentListMenu(list, pid, 0)
        var sonLength = sonList.length + 1;
        var returnCode = superiorCode + ((sonLength / 10) < 1 ? sonLength.toString().padStart(2, '0') : sonLength);
        if (pid == 0) {
            returnCode = 'A' + ((sonLength / 10) < 1 ? sonLength.toString().padStart(2, '0') : sonLength);
        }
        return returnCode
    },

    // 获取全部部门
    async getAllDepartmentList() {
        var list = []
        let requestData = await vueObject.$http.getAllDepartmentList()
        if (requestData.status == 200) {
            list = requestData.result
        } else {
            vueObject.$message({
                type: 'error',
                message: saveData.messsage
            });
        }
        return list
    },

    // 整理部门树
    departmentListMenu(data, id = 0, lev = 0, selectId = '') {
        var son = []
        data.forEach((value, keys) => {
            if (selectId == value['depId']) {
                value['disabled'] = true;
            }
            if (value['pdepId'] == id) {
                value['value'] = value['depId']
                value['label'] = value['depName']
                value['lev'] = lev;
                value['children'] = this.departmentListMenu(data, value['depId'], lev + 1);
                son.push(value)
            }
        })
        return son;
    },
    // 获取操作按钮列表（按 jurSort 升序）
    async getActionButton() {
        var buttonList = [], menuList = ""
        if (sessionStorage.getItem("savePage")) {
            menuList = JSON.parse(sessionStorage.getItem("savePage"))
            buttonList = menuList.list || []
        }
        console.log(buttonList.sort(this.compare('jurSort')), "buttonList")
        return buttonList.sort(this.compare('jurSort'))
    },
    // 按钮排序
    compare(property) {
        return function (a, b) {
            var value1 = Number(a[property]) || 0
            var value2 = Number(b[property]) || 0
            return value1 - value2
        };
    },

    refreshPage() {
        window.location.href = ""
    },
    // 获取页面菜单
    async getPageMenuList(id) {
        var menuList = vueObject.$store.getters.getMenuList
        var dataList = {}
        menuList.forEach((menuOneValue, menuOneKey) => {
            if (id == menuOneValue.jurId) {

                menuOneValue.list.forEach((menuTwoValue, menuTwoKey) => {
                    var sessionName = menuTwoValue.jurParentid
                    if (sessionStorage.getItem(sessionName)) {
                        var saveOsnPage = JSON.parse(sessionStorage.getItem(sessionName))
                        console.log(saveOsnPage)
                        if (menuTwoValue.jurId == saveOsnPage.jurId) {
                            menuTwoValue.list.forEach((menuThreeValue, menuThreeKey) => {
                                menuTwoValue.list.forEach((menuThreeValue, menuThreeKey) => {
                                    if (menuThreeValue.jurId == menuTwoValue.actionType) {
                                        menuOneValue.defaultMenu = menuThreeValue
                                    }
                                })
                            })
                        }
                    }

                    dataList = menuOneValue
                })

            }
        })
        return dataList
    },

    // 获取页面菜单
    async getPageMenuListNew(page, defaultPage = "") {
        var menuList = vueObject.$store.getters.getMenuList
        var dataList = {}
        menuList.forEach((menuOneValue, menuOneKey) => {
            if (page == menuOneValue.jurHomepage) {

                menuOneValue.list.forEach((menuTwoValue, menuTwoKey) => {
                    var sessionName = menuTwoValue.jurParentid
                    if (sessionStorage.getItem(sessionName)) {
                        var saveOsnPage = JSON.parse(sessionStorage.getItem(sessionName))
                        if (menuTwoValue.jurId == saveOsnPage.jurId) {
                            menuTwoValue.list.forEach((menuThreeValue, menuThreeKey) => {
                                var savePage = JSON.parse(sessionStorage.getItem('savePage'))
                                if (savePage) {
                                    if (menuThreeValue.jurId == savePage.jurId) {
                                        console.log(savePage)
                                        menuOneValue.defaultMenu = menuThreeValue
                                        sessionStorage.removeItem("savePage");
                                    }
                                } else {
                                    if (menuThreeValue.jurId == menuTwoValue.actionType) {
                                        menuOneValue.defaultMenu = menuThreeValue
                                    }
                                }

                            })
                            // })
                        }
                    }

                    dataList = menuOneValue
                })

            }
        })
        return dataList
    },



    /**
     * 获取子孙树
     * @param   array        $data   待分类的数据
     * @param   int/string   $id     要找的子节点id
     * @param   int          $lev    节点等级
     */
    getSubTree(data, id = 0, lev = 0, selectId = '') {
        var son = []
        data.forEach((value, keys) => {
            // if (selectId == value['ormId']) {
            //     value['disabled'] = true;
            // }
            if (value['ormParentid'] == id) {
                value['value'] = value['ormId']
                value['label'] = value['ormName']
                value['lev'] = lev;
                var list = this.getSubTree(data, value['ormId'], lev + 1);
                if (list.length >= 1) {
                    value['children'] = this.getSubTree(data, value['ormId'], lev + 1);
                }
                son.push(value)
            }
        })
        return son;
    },




    // 获取全部组织
    async getALLOrg(selectId = '') {
        var list = []
        let requestData = await vueObject.$http.getALLOrg()
        if (requestData && requestData.status == 200) {
            list = this.getSubTree(requestData.result.ormList, 0, 0, selectId)
        } else {
            vueObject.$message({
                type: 'error',
                message: saveData.messsage
            });
        }
        return list
    },

    // 获取全部组织
    async getALLOrgData() {
        var list = []
        let requestData = await vueObject.$http.getALLOrg()
        if (requestData && requestData.status == 200) {
            list = requestData.result.ormList
        } else {
            vueObject.$message({
                type: 'error',
                message: saveData.messsage
            });
        }

        return list
    },
    // 赋值为零
    getNumber(arr, info) {
        var infos = JSON.parse(JSON.stringify(info))
        arr.forEach(item => {
            if (info[item] == "" || info[item] == null || info[item] == undefined) {
                infos[item] = 0
            }
        })
        return infos
    },
    /**
     * cate 类型，1数量，2单价，3总价
     * num 要操作的数值
     */
    getDecimalInfo(cate = 1, num) {
        var newNumber = parseFloat(num)
        if (newNumber == 0) {
            return newNumber
        }
        var returnValue = newNumber
        var settingInfo = sessionStorage.getItem('systemSettingInfo')
        if (settingInfo) {
            settingInfo = JSON.parse(settingInfo)
            switch (cate) {
                case 1://数量
                    // returnValue = newNumber.toFixed(settingInfo.decimaldigits.numDigits)
                    // returnValue = this.toFixed2(newNumber, settingInfo.decimaldigits.numDigits)
                    returnValue = NP.round(newNumber, settingInfo.decimaldigits.numDigits)
                    break;
                case 2://价格
                    // returnValue = newNumber.toFixed(settingInfo.decimaldigits.priceDigits)
                    // returnValue = this.toFixed2(newNumber, settingInfo.decimaldigits.priceDigits)//
                    returnValue = NP.round(newNumber, settingInfo.decimaldigits.priceDigits)//
                    break;
                case 3://金额
                    // returnValue = newNumber.toFixed(settingInfo.decimaldigits.moneyDigits)
                    // returnValue = this.toFixed2(newNumber, settingInfo.decimaldigits.moneyDigits)
                    returnValue = NP.round(newNumber, settingInfo.decimaldigits.moneyDigits)
                    break;
                case 4:
                    // returnValue = newNumber.toFixed(settingInfo.decimaldigits.moneyDigits)
                    returnValue = this.toFixed2(newNumber, 10)
                    break;
                case 9://保留两位小数
                    returnValue = this.toFixed2(newNumber, 2)
                    break;
                case 10://
                    returnValue = String(Number(returnValue)).indexOf('NaN') != -1 || String(Number(returnValue)).indexOf('Infinity') != -1 ? 0 : Number(returnValue)
                    break;
            }
        }
        return String(Number(returnValue)).indexOf('NaN') != -1 || String(Number(returnValue)).indexOf('Infinity') != -1 ? 0 : Number(returnValue);
    },

    // 重写
    toFixed2(number, decimal) {
        console.log(decimal, "测试");
        decimal = decimal || 0;
        var flag = false
        var s = String(Number(number)).indexOf('NaN') != -1 || String(Number(number)).indexOf('Infinity') != -1 ? 0 : String(Number(number));
        if (s == 0) {
            return 0
        }
        if (s.substring(0, 1) == "-") {
            flag = true
            s = String(Math.abs(Number(s)))
        }
        var decimalIndex = s.indexOf('.');
        if (decimalIndex < 0) {
            var fraction = '';
            for (var i = 0; i < decimal; i++) {
                fraction += '0';
            }
            if (flag) {
                return '-' + s + '.' + fraction;
            } else {
                return s + '.' + fraction;
            }
        }
        var numDigits = s.length - 1 - decimalIndex;
        if (numDigits <= decimal) {
            var fraction = '';
            if (decimal - numDigits == 0) {
                if (flag) {
                    return '-' + s
                } else {
                    return s
                }
            } else {
                for (var i = 0; i < decimal - numDigits; i++) {
                    fraction += '0';
                }
            }
            if (flag) {
                return '-' + s + fraction;
            } else {
                return s + fraction;
            }
        }
        var digits = s.split('');
        var pos = decimalIndex + decimal;
        var roundDigit = digits[pos + 1];
        if (roundDigit > 4) {
            //跳过小数点
            if (pos == decimalIndex) {
                --pos;
            }
            digits[pos] = Number(digits[pos] || 0) + 1;
            //循环进位
            while (digits[pos] == 10) {
                digits[pos] = 0;
                --pos;
                if (pos == decimalIndex) {
                    --pos;
                }
                if (pos == -1) {
                    digits.unshift(1)
                } else {
                    digits[pos] = Number(digits[pos] || 0) + 1;
                }
            }
        }
        //避免包含末尾的.符号
        if (decimal == 0) {
            decimal--;
        }
        if (flag) {
            return "-" + digits.slice(0, decimalIndex + decimal + 1).join('');
        } else {
            return digits.slice(0, decimalIndex + decimal + 1).join('');
        }

    },
    //开头为0,第二位不为小数点的修改 例如：01=1
    updataNum(type, rows) {
        var info = rows
        let a = info[type] ? String(info[type]) : '0';
        if (info[type] == "") {
            info[type] = 0;
        } else if (
            a.length > 1 &&
            a.substring(0, 1) == "0" &&
            a.substring(1, 2) != "."
        ) {
            info[type] = a.substring(1, a.length);
        }
        return info
    },
    // 生成拼音助记码
    createPinyinCode(str, val) {
        var regex = /[\u4e00-\u9fa5\u3000-\u303F]/;
        if (regex.test(val)) {
            return val
        } else {
            var pinyinData = pinyin(str, { pattern: 'first', type: 'array', toneType: "none" });
            return pinyinData.join("").toUpperCase();
        }

    },
    //生成从minNum到maxNum的随机数
    randomNum(minNum, maxNum) {
        switch (arguments.length) {
            case 1:
                return parseInt(Math.random() * minNum + 1, 10);
                break;
            case 2:
                return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
                break;
            default:
                return 0;
                break;
        }
    },

    // 只允许选今天及以前
    disabledDateOne(time) {
        return time.getTime() > Date.now();
    },


    /**
     * 根据日期计算年龄
     * @param timeStamp  13位的时间戳
     */
    calculationAges(timeStamp) {
        var dateStr = this.timeStampToDate(timeStamp)
        var r = dateStr.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/);
        if (r == null) return false;
        var d = new Date(r[1], r[3] - 1, r[4]);
        if (d.getFullYear() == r[1] && (d.getMonth() + 1) == r[3] && d.getDate() == r[4]) {
            var Y = new Date().getFullYear();
            return (Y - r[1]);
        }
        return 0;
    },


    /**
     * 退出登录
     */
    loginOut() {
        sessionStorage.clear()
        vueObject.$router.push('/login');
    },

    /**
     * 页面跳转
     * @param {string} topath 要跳转的页面  
     * @param {number 0 /1 } jumpMode 是否要新建页面
     */
    pageJump(topath, jumpMode = 0) {
        if (jumpMode == 1) {
            window.open(topath, '_blank', 'width=1440,height=1080,menubar=no,toolbar=no,status=no,scrollbars=yes');
            return false
        }
        if (topath == vueObject.$route.path) {
            return false;
        }

        if (topath == '') {
            return false;
        }
        sessionStorage.setItem('thisPagePath', topath)
        vueObject.$router.push(topath);
    },

    // 获取当前页面
    getThisPage() {
        return vueObject.$route.path
    },

    /**
     * 判断当前页面
     */
    pageClass(pageLink) {
        if (vueObject.$route.path == pageLink) {
            return true
        }
        return false
    },

    // 获取当前时间戳
    getDateNumber() {
        return moment().valueOf();
    },

    // 获取开始时间
    getStartTime() {
        return new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000 //开始上一个月
    },

    // 获取结束时间
    getEndTime() {
        return new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1 // 当天最后一秒
    },
    //获取当天0点
    getNewDayTime() {
        return new Date(new Date().toLocaleDateString()).getTime() // 当天最后一秒
    },

    // unix（10位的）时间戳转换 年月日
    dateFormatDate(thisTime) {
        return moment.unix(thisTime).format('YYYY-MM-DD')
    },

    // unix（10位的）时间戳转换 年月日时分秒
    dateFormatDateTwo(thisTime) {
        return moment.unix(thisTime).format('YYYY-MM-DD HH:mm:ss')
    },

    // js（13位的）时间戳转换 年月日
    timeStampToDate(thisTime) {
        return moment(thisTime).format('YYYY-MM-DD')
    },



    /**  
     * 将以base64的图片url数据转换为Blob  
     * @param urlData  
     *            用url方式表示的base64图片数据  
     */
    convertBase64UrlToBlob(urlData) {

        var bytes = window.atob(urlData.split(',')[1]); //去掉url的头，并转换为byte  

        //处理异常,将ascii码小于0的转换为大于0  
        var ab = new ArrayBuffer(bytes.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < bytes.length; i++) {
            ia[i] = bytes.charCodeAt(i);
        }

        return new Blob([ab], { type: 'image/png' });
    },

    /**
     * 将以base64的图片url转换为File
     * @param urlData  用url方式表示的base64图片数据  
     * @param fileName  文件名字  
     */
    base64ToFile(urlData, fileName) {
        let arr = urlData.split(',');
        let mime = arr[0].match(/:(.*?);/)[1];
        let bytes = atob(arr[1]); // 解码base64
        let n = bytes.length
        let ia = new Uint8Array(n);
        while (n--) {
            ia[n] = bytes.charCodeAt(n);
        }
        return new File([ia], fileName, { type: mime });
    },
    /**
     * @param limit 大小长度B字节
     */
    fileSizeString(limit) {
        var size = "";
        if (limit < 0.1 * 1024) { //小于0.1KB，则转化成B
            size = limit.toFixed(2) + "B"
        } else if (limit < 0.1 * 1024 * 1024) { //小于0.1MB，则转化成KB
            size = (limit / 1024).toFixed(2) + "KB"
        } else if (limit < 0.1 * 1024 * 1024 * 1024) { //小于0.1GB，则转化成MB
            size = (limit / (1024 * 1024)).toFixed(2) + "MB"
        } else { //其他转化成GB
            size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB"
        }

        var sizeStr = size + ""; //转成字符串
        var index = sizeStr.indexOf("."); //获取小数点处的索引
        var dou = sizeStr.substr(index + 1, 2) //获取小数点后两位的值
        if (dou == "00") { //判断后两位是否为00，如果是则删除00
            return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2)
        }
        return size;
    },
    /**
     * 获取文件名称
     * @param {fileUrl}   文件Url
     */
    getFileName(fileUrl) {
        var index = fileUrl.lastIndexOf("\/");
        var fileName = fileUrl.substring(index + 1, fileUrl.length);
        return fileName
    },

    /**
     * 
     * @param {*} event  上传对象
     * @param {*} fileUploadType 上传类型1 file上传,2base64上传
     */
    async fileUpload(event, fileUploadType = 1) {
        if (fileUploadType == 1) {
            if (event.target.files.length <= 0) {
                return false
            }
            var fileUpload = event.target.files[0];

        } else {
            var fileUpload = event;
        }


        var requestData = {
            file: fileUpload
        }
        const loading = vueObject.$loading({
            lock: true,
            text: '文件上传中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        let saveData = await vueObject.$Http.oneFileUpload(requestData, true)
        if (saveData.code == 200) {
            vueObject.$message({
                type: 'success',
                message: '文件上传成功'
            });
            loading.close();
            var newFileInfo = {};
            for (var testData in saveData.data) {
                newFileInfo = {
                    fileName: testData,
                    fileUrl: saveData.data[testData],
                    fileSize: fileUpload.size,
                }
            }
            return newFileInfo;
        } else {
            loading.close();
            vueObject.$message({
                type: 'error',
                message: saveData.messsage
            });
        }

    },

    // 在线预览
    viewFile(fileUrl) {
        let onlineViewType = ['doc', 'docx', 'xls', 'xlsx', 'xlsm', 'ppt', 'pptx']
        let fileTypeName = fileUrl.substring(fileUrl.lastIndexOf('.') + 1, fileUrl.length).split('?')[0]
        let isWord = onlineViewType.find((type) => type === fileTypeName)
        if (isWord) {
            var url = vueObject.$store.state.webConfig.fileUrl + fileUrl
            window.open(url, '_blank')
        }

    },



    //格式化数字
    formatDig(num) {
        return num > 9 ? '' + num : '0' + num;
    },

    //格式化日期
    formatDate(mill) {
        var y = new Date(mill);
        let raws = [
            y.getFullYear(),
            this.formatDig(y.getMonth() + 1),
            this.formatDig(y.getDate())
        ];
        let format = ['-', '-', ''];
        return String.raw({ raw: raws }, ...format);
    },

    // 获取季度 （已过的不能选择）
    createQuarter(year, isInitDisable) {
        var quarterDays = [];
        var isDisableArr = [true, true, true, true];

        if (!isInitDisable) {
            var currentMonth = new Date().getMonth();
            var currentYear = new Date().getFullYear();
            isDisableArr = [false, false, false, false];
            if (year > currentYear) {
                isDisableArr = [false, false, false, false];
            } else if (year < currentYear) {
                isDisableArr = [true, true, true, true];
            } else {
                if (currentMonth > 8) {
                    isDisableArr = [true, true, true, false];
                } else if (currentMonth > 5) {
                    isDisableArr = [true, true, false, false];
                } else if (currentMonth > 2) {
                    isDisableArr = [true, false, false, false];
                }
            }
        }

        var prefix = year + '-';
        quarterDays.push({
            'start': prefix + '01-01',
            'end': prefix + '03-31',
            'disable': isDisableArr[0],
            'dateName': '第一季度',
            'dateRange': prefix + '01-01' + '~' + prefix + '03-31'
        });
        quarterDays.push({
            'start': prefix + '04-01',
            'end': prefix + '06-30',
            'disable': isDisableArr[1],
            'dateName': '第二季度',
            'dateRange': prefix + '04-01' + '~' + prefix + '06-30'

        });
        quarterDays.push({
            'start': prefix + '07-01',
            'end': prefix + '09-30',
            'disable': isDisableArr[2],
            'dateName': '第三季度',
            'dateRange': prefix + '07-01' + '~' + prefix + '09-30'
        });
        quarterDays.push({
            'start': prefix + '10-01',
            'end': prefix + '12-31',
            'disable': isDisableArr[3],
            'dateName': '第四季度',
            'dateRange': prefix + '10-01' + '~' + prefix + '12-31'
        });

        return quarterDays;
    },

    // 获取季度 (未到的不能选择)
    createQuarterTwo(year = '', isInitDisable) {
        if (year == '') {
            year = this.getThisYear()
        }
        var quarterDays = [];
        var isDisableArr = [true, true, true, true];

        if (!isInitDisable) {
            var currentMonth = new Date().getMonth();
            var currentYear = new Date().getFullYear();
            isDisableArr = [false, false, false, false];
            if (year > currentYear) {
                isDisableArr = [false, false, false, false];
            } else if (year < currentYear) {
                isDisableArr = [true, true, true, true];
            } else {

                if (currentMonth >= 10) {
                    isDisableArr = [true, true, true, true];
                } else if (currentMonth >= 7) {
                    isDisableArr = [true, true, true, false];
                } else if (currentMonth >= 4) {
                    isDisableArr = [true, true, false, false];
                }
            }
        }

        var prefix = year + '-';
        quarterDays.push({
            'start': prefix + '01-01',
            'end': prefix + '03-31',
            'startInt': new Date(prefix + '01-01').getTime(),
            'endInt': new Date(prefix + '03-31').getTime(),
            'disable': !isDisableArr[0],
            'dateName': '第一季度',
            'dateRange': prefix + '01-01' + '~' + prefix + '03-31',
            'dateNumber': 1
        });
        quarterDays.push({
            'start': prefix + '04-01',
            'end': prefix + '06-30',
            'startInt': new Date(prefix + '04-01').getTime(),
            'endInt': new Date(prefix + '06-30').getTime(),
            'disable': !isDisableArr[1],
            'dateName': '第二季度',
            'dateRange': prefix + '04-01' + '~' + prefix + '06-30',
            'dateNumber': 2


        });
        quarterDays.push({
            'start': prefix + '07-01',
            'end': prefix + '09-30',
            'startInt': new Date(prefix + '07-01').getTime(),
            'endInt': new Date(prefix + '09-30').getTime(),
            'disable': !isDisableArr[2],
            'dateName': '第三季度',
            'dateRange': prefix + '07-01' + '~' + prefix + '09-30',
            'dateNumber': 3

        });
        quarterDays.push({
            'start': prefix + '10-01',
            'end': prefix + '12-31',
            'startInt': new Date(prefix + '10-01').getTime(),
            'endInt': new Date(prefix + '12-31').getTime(),
            'disable': !isDisableArr[3],
            'dateName': '第四季度',
            'dateRange': prefix + '10-01' + '~' + prefix + '12-31',
            'dateNumber': 4
        });

        return quarterDays;
    },

    // 获取月
    createMonths(year, isInitDisable) {
        var monthDays = [];
        var isDisable = true;
        for (var i = 0; i < 12; i++) {
            var thisMonthData = {}
            if (!isInitDisable) {
                var currentMonth = new Date().getMonth();
                var currentYear = new Date().getFullYear();
                if (year > currentYear) {
                    isDisable = false;
                } else {
                    if (i >= currentMonth && year == currentYear) {
                        isDisable = false;
                    }
                }
            }
            var prefix = year + '-' + this.formatDig(parseInt(i) + 1);
            var thisMonthNum = this.formatDig(parseInt(i) + 1)
            if (i == 0 || i == 2 || i == 4 || i == 6 || i == 7 || i == 9 || i == 11) {
                thisMonthData = {
                    'start': prefix + '-01',
                    'end': prefix + '-31',
                    'disable': isDisable,
                    'dateRange': prefix + '-01' + '~' + prefix + '-31',
                    'dateName': thisMonthNum + '月'
                }
                // monthDays.push({'start': prefix + '-01', 'end': prefix + '-31', 'disable': isDisable});
            } else if (i == 3 || i == 5 || i == 8 || i == 10) {
                thisMonthData = {
                    'start': prefix + '-01',
                    'end': prefix + '-30',
                    'disable': isDisable,
                    'dateRange': prefix + '-01' + '~' + prefix + '-30',
                    'dateName': thisMonthNum + '月'
                }
                // monthDays.push({'start': prefix + '-01', 'end': prefix + '-30', 'disable': isDisable});
            } else if (i == 1) {
                var cond1 = year % 4 == 0;
                var cond2 = year % 100 != 0;
                var cond3 = year % 400 == 0;
                var cond = cond1 && cond2 || cond3;
                if (cond) {
                    thisMonthData = {
                        'start': prefix + '-01',
                        'end': prefix + '-29',
                        'disable': isDisable,
                        'dateRange': prefix + '-01' + '~' + prefix + '-29',
                        'dateName': thisMonthNum + '月'
                    }
                    // monthDays.push({'start': prefix + '-01', 'end': prefix + '-29', 'disable': isDisable});
                } else {
                    thisMonthData = {
                        'start': prefix + '-01',
                        'end': prefix + '-28',
                        'disable': isDisable,
                        'dateRange': prefix + '-01' + '~' + prefix + '-28',
                        'dateName': thisMonthNum + '月'
                    }
                    // monthDays.push({'start': prefix + '-01', 'end': prefix + '-28', 'disable': isDisable});
                }
            }

            monthDays.push(thisMonthData)
        }
        return monthDays;
    },

    // 获取星期
    * createWeeks(year) {
        const ONE_DAY = 24 * 3600 * 1000;
        let start = new Date(year, 0, 1),
            end = new Date(year, 11, 31);
        let firstDay = start.getDay() || 7,
            lastDay = end.getDay() || 7;
        let startTime = +start,
            endTime = startTime + (7 - firstDay) * ONE_DAY,
            _endTime = end - (7 - lastDay) * ONE_DAY;
        yield [startTime, endTime];
        startTime = endTime + ONE_DAY;
        endTime = endTime + 7 * ONE_DAY;
        while (endTime < _endTime) {
            yield [startTime, endTime];
            startTime = endTime + ONE_DAY;
            endTime = endTime + 7 * ONE_DAY;
        }
        yield [startTime, +end];
    },

    // 返回星期数据
    returnWeek(year) {
        var weekArray = []
        let index = 1;
        let currentTime = Date.parse(new Date());
        for (let i of this.createWeeks(year)) {
            let start = i[0],
                end = i[1];
            let j = index++,
                isWeekDisable = false;
            //设置周是否禁用
            if (currentTime > (end + 86400000)) {
                isWeekDisable = true
            }
            weekArray.push({
                'week': this.formatDig(j),
                'dateName': '第' + this.formatDig(j) + '周',
                'start': this.formatDate(start),
                'end': this.formatDate(end),
                'disable': isWeekDisable,
                'dateRange': this.formatDate(start) + '~' + this.formatDate(end),
                'key': this.formatDate(end).substring(0, 5) + this.formatDig(j)
            });

        }

        return weekArray
    },

    // 获取当前年份
    getThisYear() {
        var myDate = new Date();
        var tYear = myDate.getFullYear();
        return tYear;
    },

    // 获取一年的开始AND结束时间戳
    getYearTime(startTime) {
        var timeStamp = {
            startTime: startTime,
            endTime: moment(startTime).endOf("year").valueOf()
        }
        return timeStamp
    },

    // 获取一个季度的开始AND结束时间戳
    getQuarterTime(startNumber) {
        var quarterTime = moment().quarter(startNumber).valueOf()
        var timeStamp = {
            startTime: moment(quarterTime).startOf("quarter").valueOf(),
            endTime: moment(quarterTime).endOf("quarter").valueOf()
        }
        return timeStamp
    },

    // 获取一个月的开始AND结束时间戳
    getMonthTime(startTime) {
        var timeStamp = {
            startTime: startTime,
            endTime: moment(startTime).endOf("month").valueOf()
        }
        return timeStamp
    },

    // 获取一个星期的开始AND结束时间戳
    getWeekTime(startTimes) {

        var timeStamp = {
            startTime: moment(startTimes).valueOf(),
            endTime: moment(startTimes).endOf("week").valueOf()
        }
        return timeStamp
    },

    // 获取年季度月周时间戳
    getPartTimeStamp() {
        var timeStamp = {
            yearTime: moment().startOf('year'),
            monthTime: moment().startOf('month'),
            quarterTime: moment().quarter(),
            weekTime: moment().startOf('week'),
        }
        return timeStamp
    },

    // 删除单号信息
    async delOrderInfo(orderId) {
        if (orderId == '' || orderId == null) return
        let params = {
            ids: [orderId]
        }
        let requestData = await vueObject.$http.deleteBillNum(params)
        if (requestData && requestData.status == 200) { } else {
            vueObject.$message({
                type: 'error',
                message: saveData.messsage
            });
        }
    },
    checkIsPrint() {
        let info = JSON.parse(sessionStorage.getItem("userInfo"));
        let isPrint = info.isPrint == 1 ? true : false
        return isPrint
    },
    //批量打印图片
    batchPrintImage(imgArr) {
        // console.log(imgArr)
        var newDiv = document.createElement("div");
        var html = '<div id="printBox" style="height: 1100px;width: 800px;">'

        imgArr.forEach(async item => {
            let img = new Image()
            img.src = item
            console.log(img)
            let str = ""
            let imgbox = document.createElement("div")
            let s = document.createElement("img")
            s.setAttribute('src', item)
            imgbox.appendChild(s)
            img.onload = () => {
                if (img.width > img.height) {
                    console.log("宽")
                    str += '<img src="' + item + '"  style="width: 1100px;height: 800px;page-break-after: always; transform: rotateZ(90deg);left:-148px;bottom:148px;"/>'
                } else {
                    console.log("宽22")
                    str += '<img src="' + item + '" style="width: 800px;height: 1100px;page-break-after: always;" />'
                }
            }
            html += str
        })
        html += '</div>'
        // 创建一个新的div元素
        var newDiv = document.createElement('div');

        // // 为新div添加内容
        // var newContent = document.createTextNode(html);
        // newDiv.appendChild(newContent);

        // // 将新div添加到body中
        // document.body.appendChild(newDiv);


        let ss = document.createElement("div");
        // newDiv.appendChild(ss)
        ss.innerHTML = html

        newDiv.appendChild(ss)
        console.log(ss, newDiv)


        printJS({
            printable: ss,
            type: 'html',
            header: null,
            // imageStyle: `display: block;margin: 0 auto;page-break-after: always;max-height: 1100px;max-width: 800px;height:100%;`,
            size: "@page { size: A4; } @media print{page-break-after: always;}"
        })
    },
    sortChange(column, list, typeList, type) {
        var dataList = []
        // 深拷贝当前列表数据
        const arr = JSON.parse(JSON.stringify(list));

        // 检查是否有任何项可以转换为有效数字（排除空字符串）
        const hasValidNumbers = arr.some(item => {
            const value = item[column.prop];
            // 检查值不是空字符串且可以转换为有效数字
            return value !== "" && !isNaN(Number(value));
        });

        // 查找匹配的字段类型
        const fieldType = typeList.find(item => item[type] === column.prop);

        if (!fieldType) return;

        if (column.order === 'descending') {
            // 降序排序（从大到小）
            if (hasValidNumbers) {
                arr.sort((a, b) => {
                    const valueA = a[column.prop];
                    const valueB = b[column.prop];

                    // 处理空字符串
                    if (valueA === "" && valueB === "") return 0;
                    if (valueA === "") return -1;  // 空字符串排在最后
                    if (valueB === "") return 1;   // 空字符串排在最后

                    // 处理非数字值
                    const numA = Number(valueA);
                    const numB = Number(valueB);

                    if (isNaN(numA) && isNaN(numB)) {
                        // 两个都是非数字，按字符串排序
                        return String(valueB).localeCompare(String(valueA));
                    }
                    if (isNaN(numA)) return 1;  // 非数字排在数字之后
                    if (isNaN(numB)) return -1; // 非数字排在数字之后

                    // 两个都是数字，按数值降序排序
                    return numB - numA;
                });
            } else {
                // 没有有效数字，全部按字符串降序排序
                arr.sort((a, b) => {
                    const valueA = a[column.prop] || "";
                    const valueB = b[column.prop] || "";
                    return String(valueB).localeCompare(String(valueA));
                });
            }
            dataList = arr;
        } else if (column.order === 'ascending') {
            // 升序排序（从小到大）
            if (hasValidNumbers) {
                arr.sort((a, b) => {
                    const valueA = a[column.prop];
                    const valueB = b[column.prop];

                    // 处理空字符串
                    if (valueA === "" && valueB === "") return 0;
                    if (valueA === "") return 1;   // 空字符串排在最后
                    if (valueB === "") return -1;  // 空字符串排在最后

                    // 处理非数字值
                    const numA = Number(valueA);
                    const numB = Number(valueB);

                    if (isNaN(numA) && isNaN(numB)) {
                        // 两个都是非数字，按字符串排序
                        return String(valueA).localeCompare(String(valueB));
                    }
                    if (isNaN(numA)) return 1;  // 非数字排在数字之后
                    if (isNaN(numB)) return -1; // 非数字排在数字之后

                    // 两个都是数字，按数值升序排序
                    return numA - numB;
                });
            } else {
                // 没有有效数字，全部按字符串升序排序
                arr.sort((a, b) => {
                    const valueA = a[column.prop] || "";
                    const valueB = b[column.prop] || "";
                    return String(valueA).localeCompare(String(valueB));
                });
            }
            dataList = arr;
        } else {
            // 重置为原始数据
            dataList = JSON.parse(JSON.stringify(list));
        }
        return dataList;
    },
    /**
     * 根据 formatterContent 字典将存储值转为展示文案
     * @param {string|Array} str 字典配置，形如 [{"key":"0","value":"停用"},{"key":"1","value":"启用"}]
     * @param {*} val 行数据中的实际值（通常对应 key）
     * @returns {*} 匹配到的展示文案；未匹配或异常时回退为原值
     */
    getIsGsp(str, val) {
        if (val === null || val === undefined || val === '') {
            return val == null ? '' : val;
        }
        if (!str) {
            return val;
        }
        try {
            let list = str;
            if (typeof str === 'string') {
                // 非 JSON 数组配置直接回退
                if (str.indexOf('[') === -1) {
                    return val;
                }
                list = JSON.parse(str.replace(/\\/g, ''));
            }
            if (!Array.isArray(list) || !list.length) {
                return val;
            }
            const target = String(val);
            // 优先 key -> value（存储值转展示文案）
            for (let i = 0; i < list.length; i++) {
                const item = list[i];
                if (item == null) continue;
                if (String(item.key) === target) {
                    return item.value;
                }
            }
            // 兼容反向：value -> key
            for (let i = 0; i < list.length; i++) {
                const item = list[i];
                if (item == null) continue;
                if (String(item.value) === target) {
                    return item.key;
                }
            }
            return val;
        } catch (e) {
            return val;
        }
    }
}